export default __webpack_public_path__ + "static/media/pistachio.0d0e3d1b.png";